import React, { useEffect, useRef } from 'react';

const BTN = {
  background: 'transparent',
  border: '1px solid #d1d5db',
  borderRadius: 6,
  minWidth: 28,
  height: 28,
  padding: '0 8px',
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  color: '#374151',
  marginRight: 4,
  marginBottom: 4,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};
const SEP = { width: 1, height: 20, background: '#d1d5db', margin: '0 6px 4px', flex: '0 0 auto' };

function ToolButton({ title, onClick, children, style = {} }) {
  return (
    <button
      type="button"
      title={title}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      style={{ ...BTN, ...style }}
    >
      {children}
    </button>
  );
}

export default function RichTextEditor({ value, onChange }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || '')) {
      ref.current.innerHTML = value || '';
    }
  }, [value]);

  const exec = (cmd, arg) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };

  const onInput = () => onChange(ref.current.innerHTML);

  return (
    <div>
      <div
        style={{
          padding: '6px 8px',
          border: '1px solid #d1d5db',
          borderRadius: '8px 8px 0 0',
          background: '#f9fafb',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          borderBottom: 'none',
        }}
      >
        <ToolButton title="Geri (undo)" onClick={() => exec('undo')}>↩</ToolButton>
        <ToolButton title="İrəli (redo)" onClick={() => exec('redo')}>↪</ToolButton>
        <span style={SEP} />
        <ToolButton title="Başlıq 1" onClick={() => exec('formatBlock', '<h1>')}>H1</ToolButton>
        <ToolButton title="Başlıq 2" onClick={() => exec('formatBlock', '<h2>')}>H2</ToolButton>
        <ToolButton title="Başlıq 3" onClick={() => exec('formatBlock', '<h3>')}>H3</ToolButton>
        <ToolButton title="Paraqraf" onClick={() => exec('formatBlock', '<p>')}>¶</ToolButton>
        <span style={SEP} />
        <ToolButton title="Qalın" onClick={() => exec('bold')} style={{ fontWeight: 800 }}>B</ToolButton>
        <ToolButton title="Kursiv" onClick={() => exec('italic')} style={{ fontStyle: 'italic' }}>K</ToolButton>
        <ToolButton title="Altından xətt" onClick={() => exec('underline')} style={{ textDecoration: 'underline' }}>U</ToolButton>
        <ToolButton title="Üstündən xətt" onClick={() => exec('strikeThrough')} style={{ textDecoration: 'line-through' }}>S</ToolButton>
        <span style={SEP} />
        <select
          title="Yazı ölçüsü"
          defaultValue="3"
          onMouseDown={(e) => e.preventDefault()}
          onChange={(e) => exec('fontSize', e.target.value)}
          style={{ height: 28, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 12, marginRight: 4, marginBottom: 4, background: '#fff', color: '#374151' }}
        >
          <option value="1">ən kiçik</option>
          <option value="2">kiçik</option>
          <option value="3">normal</option>
          <option value="5">böyük</option>
          <option value="7">çox böyük</option>
        </select>
        <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 4, marginBottom: 4, fontSize: 12, color: '#374151', height: 28 }}>
          Rəng
          <input
            type="color"
            title="Mətn rəngi"
            defaultValue="#111827"
            onMouseDown={(e) => e.preventDefault()}
            onChange={(e) => exec('foreColor', e.target.value)}
            style={{ width: 26, height: 26, border: 'none', padding: 0, background: 'transparent', cursor: 'pointer', marginLeft: 3 }}
          />
        </span>
        <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 4, marginBottom: 4, fontSize: 12, color: '#374151', height: 28 }}>
          Fon
          <input
            type="color"
            title="Fon (marker) rəngi"
            defaultValue="#fef9c3"
            onMouseDown={(e) => e.preventDefault()}
            onChange={(e) => exec('hiliteColor', e.target.value)}
            style={{ width: 26, height: 26, border: 'none', padding: 0, background: 'transparent', cursor: 'pointer', marginLeft: 3 }}
          />
        </span>
        <span style={SEP} />
        <ToolButton title="Soldan düz" onClick={() => exec('justifyLeft')}>⇤</ToolButton>
        <ToolButton title="Ortadan düz" onClick={() => exec('justifyCenter')}>⇔</ToolButton>
        <ToolButton title="Sağdan düz" onClick={() => exec('justifyRight')}>⇥</ToolButton>
        <span style={SEP} />
        <ToolButton title="Sırasız siyahı" onClick={() => exec('insertUnorderedList')}>• Siyahı</ToolButton>
        <ToolButton title="Nömrəli siyahı" onClick={() => exec('insertOrderedList')}>1. Siyahı</ToolButton>
        <ToolButton title="Formatı sil (yalnız mətn qalır)" onClick={() => exec('removeFormat')}>Təmizlə</ToolButton>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={onInput}
        spellCheck={false}
        style={{
          minHeight: 160,
          maxHeight: 420,
          overflowY: 'auto',
          border: '1px solid #d1d5db',
          borderRadius: '0 0 8px 8px',
          padding: '12px 14px',
          fontSize: 14,
          lineHeight: 1.7,
          outline: 'none',
          background: '#fff',
          fontFamily: 'inherit',
          color: '#1f2937',
        }}
      />
    </div>
  );
}